import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface QRCodeDisplayProps {
  url: string;
  size?: number;
}

export function QRCodeDisplay({ url, size = 200 }: Readonly<QRCodeDisplayProps>) {
  const { t } = useTranslation();
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    QRCode.toDataURL(url, { width: size, margin: 2 })
      .then(setDataUrl)
      .catch(() => {
        /* QR generation failed — component stays hidden (returns null) */
      });
  }, [url, size]);

  const handleDownload = useCallback(async () => {
    const highRes = await QRCode.toDataURL(url, { width: 1024, margin: 2 });
    const a = document.createElement('a');
    a.href = highRes;
    a.download = 'voicequote-qr.png';
    a.click();
  }, [url]);

  if (!dataUrl) return null;

  return (
    <div className="space-y-2">
      <img src={dataUrl} alt={t('profile.qrCode')} className="rounded border border-border" />
      <p className="text-xs text-muted-foreground">{t('profile.qrDescription')}</p>
      <Button variant="outline" size="sm" onClick={handleDownload}>
        <Download className="mr-1 h-4 w-4" />
        {t('profile.downloadQr')}
      </Button>
    </div>
  );
}
